import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface ConfirmationModalProps {
  isOpen: boolean;
  status: "success" | "error" | "confirm" | null;
  message?: string;
  onClose: () => void;
  onConfirm?: () => void;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  status,
  message,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        {status === "success" ? (
          <Typography
            color="success.main"
            variant="h6"
            display="flex"
            alignItems="center"
          >
            <CheckCircleIcon sx={{ mr: 1, color: "success.main" }} /> Envoi
            Réussi
          </Typography>
        ) : status === "error" ? (
          <Typography
            color="error.main"
            variant="h6"
            display="flex"
            alignItems="center"
          >
            <ErrorIcon sx={{ mr: 1, color: "error.main" }} /> Envoi Échoué
          </Typography>
        ) : status === "confirm" ? (
          <Typography
            color="warning.main"
            variant="h6"
            display="flex"
            alignItems="center"
          >
            <HelpOutlineIcon sx={{ mr: 1, color: "warning.main" }} /> Confirmer
            l'envoi
          </Typography>
        ) : (
          "Confirmation"
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "text.primary" }}>
          {message ||
            (status === "success"
              ? "Les prévisions ont été envoyées avec succès."
              : status === "error"
              ? "Une erreur est survenue lors de l'envoi des prévisions."
              : "Êtes-vous sûr de vouloir envoyer ces prévisions ?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {status === "confirm" && onConfirm && (
          <>
            <Button
              onClick={onConfirm}
              variant="contained"
              color="primary"
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={20} /> : null}
            >
              {isLoading ? "Envoi..." : "Confirmer"}
            </Button>
            <Button
              onClick={onClose}
              variant="outlined"
              color="primary"
              disabled={isLoading}
            >
              Annuler
            </Button>
          </>
        )}
        {status !== "confirm" && (
          <Button onClick={onClose} variant="contained" color="primary">
            Fermer
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
